import { Auth } from "aws-amplify";

const forgotPasswordSubmit = async (email: string, confirmCode: string, newPassword: string) => {
  await Auth.forgotPasswordSubmit(email, confirmCode, newPassword);
};

export default forgotPasswordSubmit;
